
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import { TextOptions } from "@/model/pagePartOptions/TextOptions";

    @Component({})
    export default class TextPart extends Vue {

        // mounted(): void {
        // }

        @Prop({ default: new TextOptions() })
        options!: TextOptions;

        @Prop({ default: false })
        isAdminView!: boolean;

    }
